import { useCallback } from 'react';
import { buildExportPayload, exportFileName, serializeExport } from '../lib/export';
import type { ScenarioRunStep } from '../lib/api';

interface Props {
  scenarioId: string;
  steps: ScenarioRunStep[];
}

export function ExportButton({ scenarioId, steps }: Props) {
  const handleExport = useCallback(() => {
    const payload = buildExportPayload(scenarioId, steps);
    const blob = new Blob([serializeExport(payload)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = exportFileName(scenarioId);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  }, [scenarioId, steps]);

  return (
    <button
      type="button"
      className="button button--secondary"
      onClick={handleExport}
      disabled={steps.length === 0}
    >
      Exportar evidencia
    </button>
  );
}
